(() => {
  function initYMLowStock(root = document) {
    root.querySelectorAll('[data-ym-low-stock]').forEach((message) => {
      if (message.dataset.ymInitialized === 'true') return;

      const sectionId = message.dataset.sectionId;
      const dataElement = document.getElementById(
        `YM-LowStockData-${sectionId}`
      );

      if (!dataElement) return;

      let variants = {};

      try {
        variants = JSON.parse(dataElement.textContent);
      } catch (error) {
        console.warn('YM Low Stock: Variant data could not be read.', error);
        return;
      }

      const stockElement = message.querySelector('[data-ym-stock]');
      const sizeElement = message.querySelector('[data-ym-size]');
      const productInfo = message.closest('product-info');

      function update(variantId) {
        if (!variantId) {
          message.hidden = true;
          return;
        }

        const variant = variants[String(variantId)];

        if (!variant) {
          message.hidden = true;
          return;
        }

        /*
         * Show only when:
         * - Shopify is tracking inventory
         * - variant is available
         * - quantity is between 1 and 4
         */
        const shouldShow =
          variant.tracked &&
          variant.available &&
          variant.quantity > 0 &&
          variant.quantity < 5;

        if (!shouldShow) {
          message.hidden = true;
          return;
        }

        stockElement.textContent = variant.quantity;
        sizeElement.textContent = variant.size;
        message.hidden = false;
      }

      /*
       * Current Dawn pub/sub event.
       */
      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.variantChange
      ) {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data || !data.variant) return;

          if (
            productInfo &&
            data.sectionId &&
            productInfo.dataset.section !== data.sectionId
          ) {
            return;
          }

          update(data.variant.id);
        });
      }

      /*
       * Fallback for Dawn forks/custom themes.
       * Shopify updates the hidden name="id" field when
       * a variant is successfully selected.
       */
      if (productInfo) {
        productInfo.addEventListener('change', (event) => {
          window.requestAnimationFrame(() => {
            const variantInput = productInfo.querySelector(
              'product-form input[name="id"]'
            );

            if (variantInput?.value) {
              update(variantInput.value);
            }
          });
        });
      }

      message.dataset.ymInitialized = 'true';
    });
  }

  function boot() {
    initYMLowStock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /*
   * Re-initialize when Shopify Theme Editor reloads a section.
   */
  document.addEventListener('shopify:section:load', (event) => {
    initYMLowStock(event.target);
  });
})();